import { Routes } from "@angular/router";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";
import { IAuthGuardOptions } from "@app/shared/auth/interfaces/auth.interface";
import { AuthGuard } from "@app/shared/auth/guards/auth.guard";
import { QuotationExpirationSettingsRoutePaths } from "./quotation-expiration-settings-route-path";
import { quotationExpirationSettingsResolver } from "./resolvers/get-quotation-expiration-settings.resolver";
import { ExpirationSettingsRoutePaths } from "@app/applications/settings/domains/expiration-settings/expiration-settings-route-path";

const authGuardOptions: IAuthGuardOptions = {
  permissions: [
    ...COMMON_GUARD_OPTIONS.QUOTATION_EXPIRATION_SETTINGS.VIEW.permissions,
    ...COMMON_GUARD_OPTIONS.QUOTATION_EXPIRATION_SETTINGS.SET.permissions,
  ],
  redirectTo: ExpirationSettingsRoutePaths.ROOT,
};

export const quotationExpirationSettingsRoutes: Routes = [
  {
    path: QuotationExpirationSettingsRoutePaths.ROOT,
    loadComponent: () =>
      import("./pages/quotation-expiration-settings/quotation-expiration-settings.component").then(t => t.QuotationExpirationSettingsComponent),
    resolve: {
      quotationExpirationSettings: quotationExpirationSettingsResolver,
    },
    canActivate: [AuthGuard],
    data: { authGuardOptions },
  },
];
